'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = (0, _react.createContext)();
module.exports = exports['default'];